import script from "./AuraChatLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuraChatLayout.vue?vue&type=script&setup=true&lang=ts"

import "./AuraChatLayout.vue?vue&type=style&index=0&id=f629df8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f629df8a"]])

export default __exports__